// extracted by mini-css-extract-plugin
export default {"my_item_message":"MyMessage_my_item_message__4rtMm","my_message":"MyMessage_my_message__4+1GS","my_picture":"MyMessage_my_picture__0gPzj","my_img":"MyMessage_my_img__7tMZG"};